import api from 'api';

export const loadAnnotations = api('POST /api/annotations/grid');
export const createAnnotation = api('POST /api/annotations');
export const editAnnotation = api('PUT /api/annotations/:id');
export const deleteAnnotation = api('DELETE /api/annotations/:id');
